import {useMemo, useCallback} from 'react'

import {DayPeriod, StrengthTarget} from '../types'
import {formatISODateForDisplay, getTodayISOInTimezone} from '../utils/dateUtils'
import {getCurrentTargetForPeriod} from '../utils/strengthTargetsUtils'

export function useStrengthTargetOverviewUtils(targets: StrengthTarget[], timezone: string) {
  const todayISO = useMemo(() => getTodayISOInTimezone(timezone), [timezone])

  const getTargetForPeriod = useCallback(
    (dayPeriod: DayPeriod): StrengthTarget | undefined => {
      return getCurrentTargetForPeriod(targets, dayPeriod, todayISO)
    },
    [targets, todayISO]
  )

  const formatDate = useCallback(
    (isoDateString: string): string => {
      return formatISODateForDisplay(isoDateString, timezone)
    },
    [timezone]
  )

  const formatValidFrom = useCallback(
    (isoDateString: string): string => {
      return formatISODateForDisplay(isoDateString, timezone)
    },
    [timezone]
  )

  return {
    getCurrentTargetForPeriod: getTargetForPeriod,
    formatDate,
    formatValidFrom
  }
}
